/**
 * Endpoints de **Logística → Canjes CardPlus** (`/api/logistica/canjes`).
 *
 * La pantalla pide los canjes de un rango de fechas; si no se envían las dos
 * fechas, la API devuelve todo, como el panel anterior.
 */

import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

import type { CanjesFiltros, CanjesRespuesta } from './canjes.types';

export const canjesKeys = {
  lista: (filtros: CanjesFiltros) => ['logistica', 'canjes', filtros] as const,
} as const;

/** Arma la cadena de consulta del listado. */
function cadenaDe(filtros: CanjesFiltros): string {
  const parametros = new URLSearchParams();

  if (filtros.desde) parametros.set('desde', filtros.desde);
  if (filtros.hasta) parametros.set('hasta', filtros.hasta);

  const cadena = parametros.toString();

  return cadena ? `?${cadena}` : '';
}

export const canjesApi = {
  listar: (filtros: CanjesFiltros = {}, signal?: AbortSignal): Promise<CanjesRespuesta> =>
    apiClient.get<CanjesRespuesta>(`/api/logistica/canjes${cadenaDe(filtros)}`, { signal }),
};

/** Canjes del rango pedido. */
export function useCanjes(filtros: CanjesFiltros = {}) {
  return useQuery({
    queryKey: canjesKeys.lista(filtros),
    queryFn: ({ signal }) => canjesApi.listar(filtros, signal),
  });
}
